import { ConfigProvider, Spin } from 'antd';
import { Outlet } from 'react-router-dom';
import { useUnit } from 'effector-react';
import { useEffect } from 'react';

export const CHTheme = {
  token: {
    colorPrimary: '#27ae60',
  },
  components: {
    Select: {
      multipleItemBg: '#e9f7ef',
    },
  },
};

function App() {
  return (
    <ConfigProvider theme={CHTheme}>
      <Spin spinning={false}>
        <Outlet />
      </Spin>
    </ConfigProvider>
  );
}

export default App;
